import { FC } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { AmountAndCurrency } from 'ui/AmountAndCurrency';

type AmountRowProps = {
	label: string;
	amount: number | null;
	currency: string;
};

export const AmountRow: FC<AmountRowProps> = ({ label, amount, currency }) => (
	<TableRow>
		<TableCell sx={{ padding: '5px', borderBottom: 0 }}>{label}:</TableCell>
		<TableCell align="right" sx={{ padding: '5px', borderBottom: 0 }}>
			<AmountAndCurrency amount={amount ?? 0} currency={currency} size={0.9} />
		</TableCell>
	</TableRow>
);
